import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import {
  DataRoomNodeAccessState,
  DataRoomNodeWithStateAndSignal,
} from 'models/Lead';
import LeadsContext from '../../../../../../providers/Leads';
import ReleaseFileLoadingContext from '../../../../../../providers/ReleaseFileLoading';
import { getDataRoomNodeAccessDisplayState } from '../../../../utils';
import DisplayFilesByFileTrigger from '../DisplayFilesByFileTrigger';

import './DisplayFilesByLeadFile.styles.scss';

type DisplayFilesByLeadFileProps = {
  node: DataRoomNodeWithStateAndSignal;
  leadId: string;
  disabled: boolean;
  onCycleAccess: (
    node: DataRoomNodeWithStateAndSignal,
    currentState: DataRoomNodeAccessState,
  ) => void;
};

const DisplayFilesByLeadFile: React.FC<DisplayFilesByLeadFileProps> = (
  props,
) => {
  const { node, leadId, disabled, onCycleAccess } = props;

  const { isReleaseFileLoadingForLead } = useContext(ReleaseFileLoadingContext);
  const { isUndoingReleaseFileForNode } = useContext(LeadsContext);

  const { dataRoomNodeId, dataRoomNode, state, accessLevel } = node;
  const { name } = dataRoomNode || {};

  const displayState = getDataRoomNodeAccessDisplayState(node);

  const isLoading = useMemo(
    () =>
      isReleaseFileLoadingForLead(leadId, dataRoomNodeId) ||
      isUndoingReleaseFileForNode(dataRoomNodeId),
    [
      leadId,
      dataRoomNodeId,
      isReleaseFileLoadingForLead,
      isUndoingReleaseFileForNode,
    ],
  );

  const canChangeState = !disabled && !isLoading;

  const classes = classNames('display-files-by-lead-file', {
    clickable: canChangeState,
  });

  return (
    <DisplayFilesByFileTrigger
      className={classes}
      name={name}
      state={displayState}
      isLoading={isLoading}
      accessLevel={accessLevel}
      onClick={() => {
        if (!canChangeState) return;

        onCycleAccess(node, state);
      }}
    />
  );
};

export default DisplayFilesByLeadFile;
